module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_m_leucistic.6aa938c2.png";